<odx-chip size="small" variant="highlight">
  <odx-icon iconSet="safety" name="group" alignleft></odx-icon> {{ group.groupId }}
</odx-chip>
